import { render } from "./BreadcrumbRouterLink.vue?vue&type=template&id=4d5b33b6"
import script from "./BreadcrumbRouterLink.vue?vue&type=script&lang=js"
export * from "./BreadcrumbRouterLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__